import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';
import { Strategy } from 'utility-ts-strategy';
import ApApp from './../../../../main';
import { FeedbackSuggestedPlanModel } from './../../../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';
import { APGenericSlot } from './../../../builders/ap_generic_slot_builder';
import { ProgramSlot } from './../../../builders/ap_program_slot_builder';
import { RoleTypeStrategy } from './../../../strategies/user_mode_api_strategy';

export class MarkAsMetSlotCommandParamStrategy {
  constructor(
    private accountModel: AccountModel,
    private $state: ng.ui.IStateService,
    private ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel
  ) {}

  getParams(slot: APGenericSlot, comment?: string) {
    const pgmSlotStatus: ProgramSlot['status'] = 'MET';

    const params = {
      program_slot: slot.programSlot.id,
      status: pgmSlotStatus,
      comment: {
        message: comment
      }
    };

    const roleType = RoleTypeStrategy.evaluate(this.$state);
    const additionalParams = new Strategy<() => Record<string, unknown>>({
      student: () => ({ student: this.accountModel.student_nk }),
      advisor: () => ({ suggested_plan: this.ngFeedbackSuggestedPlanModel.read().id })
    });

    return _4.merge({}, params, additionalParams.get(roleType)());
  }

  getCommentUrl() {
    const roleType = RoleTypeStrategy.evaluate(this.$state);
    const additionalParams = new Strategy({
      student: `/coreuser/comment/`,
      advisor: `/academicplan/suggested_plan/${this.ngFeedbackSuggestedPlanModel.read().id}/comment/`
    });
    return additionalParams.get(roleType);
  }
}

angular
  .module('capability-ng-academic-planner')
  .service('ngMarkAsMetSlotCommandParamStrategy', MarkAsMetSlotCommandParamStrategy);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/mark_as_met/stratgies/mark_as_met_slot_command_param_strategy.ts